var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsOfficePhoneWhile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.32,
    height: 21.319,
    viewBox: "0 0 21.32 21.319",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-fax",
    "data-name": "Icon awesome-fax",
    d: "M2.665,5.33H1.332A1.333,1.333,0,0,0,0,6.662V19.987A1.333,1.333,0,0,0,1.332,21.32H2.665A1.333,1.333,0,0,0,4,19.987V6.662A1.333,1.333,0,0,0,2.665,5.33ZM19.987,6.662V3.217a1.333,1.333,0,0,0-.39-.942L17.713.39A1.333,1.333,0,0,0,16.77,0H6.662A1.333,1.333,0,0,0,5.33,1.332V19.987A1.333,1.333,0,0,0,6.662,21.32H19.987a1.333,1.333,0,0,0,1.332-1.332V7.995A1.333,1.333,0,0,0,19.987,6.662ZM11.992,17.988a.666.666,0,0,1-.666.666H9.994a.666.666,0,0,1-.666-.666V16.656a.666.666,0,0,1,.666-.666h1.332a.666.666,0,0,1,.666.666Zm0-5.33a.666.666,0,0,1-.666.666H9.994a.666.666,0,0,1-.666-.666V11.326a.666.666,0,0,1,.666-.666h1.332a.666.666,0,0,1,.666.666Zm5.33,5.33a.666.666,0,0,1-.666.666H15.324a.666.666,0,0,1-.666-.666V16.656a.666.666,0,0,1,.666-.666h1.332a.666.666,0,0,1,.666.666Zm0-5.33a.666.666,0,0,1-.666.666H15.324a.666.666,0,0,1-.666-.666V11.326a.666.666,0,0,1,.666-.666h1.332a.666.666,0,0,1,.666.666Zm.666-4.664H7.329V2H15.99V3.331A.666.666,0,0,0,16.656,4h1.332Z",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsOfficePhoneWhile);
export default __webpack_public_path__ + "static/media/icons-office-phone-while.4c6d360dc55e955f37bfa1f54c257023.svg";
export { ForwardRef as ReactComponent };